var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control form-control-sm",on:{"change":e => _vm.changeLanguage(e.target.value)}},_vm._l((_vm.languages),function(language){return _c('option',{domProps:{"value":language,"selected":language === _vm.$locale,"textContent":_vm._s(_vm.__('languages.with_flag.' + language))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }